"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.USPLinkWrapper = exports.USPText = exports.USPIcon = exports.USPSubTitle = exports.USPTitle = exports.USPBoxWrapper = exports.UspBoxesTitle = exports.UspBoxesWrapper = void 0;
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const styled_components_1 = __importDefault(require("styled-components"));
const fdr_regular_basis_fdr_image_1 = require("@hotelplan/fdr.regular.basis.fdr-image");
const fdr_regular_basis_fdr_route_1 = require("@hotelplan/fdr.regular.basis.fdr-route");
exports.UspBoxesWrapper = styled_components_1.default.div(({ theme: { space } }) => (0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: [`${space[4]} 0`, '50px 0'],
    '.with-link': {
        '&:hover': {
            borderColor: 'primary',
        },
    },
}));
exports.UspBoxesTitle = styled_components_1.default.h2((0, util_theme_sxc_1.sx2CssThemeFn)({
    variant: 'text.heading',
    textTransform: 'uppercase',
    marginBottom: [3, '40px'],
    textAlign: 'center',
    width: '100%',
    fontSize: [5, '36px'],
}));
exports.USPBoxWrapper = styled_components_1.default.div(({ theme }) => theme.usp.boxWrapper || {});
exports.USPTitle = styled_components_1.default.h2(({ theme }) => theme.usp.title || {});
exports.USPSubTitle = styled_components_1.default.h3(({ theme }) => theme.usp.subTitle || {});
exports.USPIcon = (0, styled_components_1.default)(fdr_regular_basis_fdr_image_1.FdrImage)(({ theme }) => theme.usp.icon || {});
exports.USPText = styled_components_1.default.div(({ theme }) => theme.usp.text || {});
exports.USPLinkWrapper = (0, styled_components_1.default)(fdr_regular_basis_fdr_route_1.FdrRoute)({
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 0,
});
//# sourceMappingURL=fdr-usp-boxes.styles.js.map